import { Injectable } from '@angular/core';
import { Employee } from './employee';
import { Customer } from './../customers/customers';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';

@Injectable({
  providedIn: 'root'
})

export class EmployeeService {



  public baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<Employee[]>([]);

  gridObject$: Observable<Employee[]> = this.subject.asObservable();
  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent) {}

  init() {

    const http$ = this.gridHttp();

    http$.pipe(
      map(res => res),
      tap(() => {
        this.isLoading = false;
      })
    ).subscribe(
      res => this.subject.next(res.Employees)
    );

  }



  saveEdit(id: number, changes): Observable<any> {

    const employees = this.subject.getValue();

    const emIndex = employees.findIndex(jobtype => jobtype.employee_id === id);
    const newEmpList = employees.slice(0);


    newEmpList[emIndex] = {
      ...employees[emIndex],
      ...changes
    };

    this.subject.next(newEmpList);
    return this.http.post(this.baseURL + '/rhAPI/employees/edit/' + id,changes).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close','errorAlert');
          this.subject.next(employees);
        } else {
          this.messager.openSnackBar(message, '', 'successAlert');
        }
      })
    )

  }

  getOneEmployee(id: number): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/employees/getOneEmployee/' + id).pipe(tap((event) => {
      const message = event.Message as unknown as string;
      if (event.Error) {
      } else {
      }
    }));
  }

  getWrongSupervisors(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/bamboo/getWrongSupervisors', {observe: 'body'})
  }

  updateSupervisor(id: number, name: string, region: string): Observable<any> {
    return this.http.post(this.baseURL + `/rhAPI/bamboo/syncSupervisorWithBamboo/${id}/${name}`, { region: region}, {observe: 'body'});
  }

  getTeamTimeOff(employeeId: number, start?: string, end?: string): Observable<any> {
    let params = new HttpParams();
    if (start) { params = params.set('start', start); }
    if (end) { params = params.set('end', end); }
    return this.http.get(this.baseURL + `/rhAPI/bamboo/getTeamTimeOff/${employeeId}`, { params: params, observe: 'body' });
  }

  add(changes): Observable<any> {
    const list = this.subject.getValue();
    const newList = list.slice(0);

    newList.unshift(changes);

    this.subject.next(newList);

    return this.http.post(this.baseURL + '/rhAPI/employees/add', changes).pipe(
     tap((event) => {
       const message = event.Message as unknown as string;
       if (event.Error) {
         this.messager.openSnackBar(message, 'Close', 'errorAlert');
         this.subject.next(list);
       } else {
         this.messager.openSnackBar(message, '', 'successAlert');
       }
     })
   );

  }

  getEmployees(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/employees/getEmployees', {observe: 'body'});
  }

  getInitial() {
      return this.gridObject$.pipe(
      map(employees => employees)
    );
  }

  gridHttp(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/employees/getEmployees', {observe: 'body'});
  }

  getEmployeeTree(employees, supervisorId) {

      const supervisorMap = {};
      for (const emp of employees) {
        const supId = emp.supervisingrater;
        if (!supervisorMap[supId]) {
          supervisorMap[supId] = [];
        }
        supervisorMap[supId].push(emp);
      }
      function recurse(currentSupervisor, visited) {

        let results = [];
        const directReports = supervisorMap[currentSupervisor] || [];
        for (const report of directReports) {
          if (visited.has(report.employee_id)) {
            continue;
          }
          visited.add(report.employee_id);
          results.push(report.employee_id);
          const subSubordinates = recurse(report.employee_id, visited);
          results = results.concat(subSubordinates);
        }
        return results;
      }
      return recurse(supervisorId, new Set());
  }


  saveTimeRecordsForWeek(changes: any): Observable<any> {
    return this.http.post(this.baseURL + `/rhAPI/time/saveTimeRecordsForWeek`, changes , {observe: 'body'});
  }

  getTimeRecordsForWeek(employee_id: number, weekStart: string): Observable<any> {
    return this.http.get(this.baseURL + `/rhAPI/time/getTimeRecordsForWeek/${employee_id}/${weekStart}`, {observe: 'body'});
  }


  getEmployeeTimeRecordsForWeek(employee_id: number, week: string, employee_type: string): Observable<any> {
    let trimmedEmployee = employee_type?.trim();
    let employee_obj = {
      employee_id : employee_id,
      week: week,
      employee_type: trimmedEmployee 
    }
    return this.http.post(this.baseURL + `/rhAPI/jobEntry/getEmployeeWeeklyHours`, employee_obj ,{observe: 'body'});
  }


  saveTimeApprovals(approvalData: any): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/timeApprovals/processComplete', approvalData, {observe: 'body'});
  }

  getApprovalHistory(week: string, managerId?: number): Observable<any> {
      const url = managerId 
          ? `${this.baseURL}/rhAPI/timeApprovals/history/${week}/${managerId}`
          : `${this.baseURL}/rhAPI/timeApprovals/history/${week}`;
      return this.http.get(url, {observe: 'body'});
  }

  createApprovalBatch(batchData: any): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/timeApprovals/createBatch', batchData, {observe: 'body'});
  }

  addIndividualApproval(approvalData: any): Observable<any> {
      return this.http.post(this.baseURL + '/rhAPI/timeApprovals/addApproval', approvalData, {observe: 'body'});
  }
  
  getExistingApprovals(week: string, managerId: number): Observable<any> {
      return this.http.get(`${this.baseURL}/rhAPI/timeApprovals/existing/${week}/${managerId}`, {observe: 'body'});
  }

  checkWeekApprovalStatus(week: string, employeeId: number): Observable<any> {
      return this.http.get(`${this.baseURL}/rhAPI/timeApprovals/checkStatus/${week}/${employeeId}`, {observe: 'body'});
  }

  getSupervisingRaters(): Observable<any> {
      return this.http.get(this.baseURL + '/rhAPI/employees/getSupervisingRaters', {observe: 'body'});
  }

  getSupervisorEmails(id: number): Observable<any> {
      return this.http.get(this.baseURL + `/rhAPI/emails/getSupervisorEmails/${id}`, {observe: 'body'});
  }

  updateEmployeeSupervisor(id: number, supervisingrater: number | null, supervisorname: string | null): Observable<any> {
    return this.http.post(this.baseURL + `/rhAPI/employees/updateSupervisor/${id}`, {
      supervisingrater: supervisingrater,
      supervisorname: supervisorname
    }, {observe: 'body'}).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
        } else {
          this.messager.openSnackBar(message, '', 'successAlert');
        }
      })
    );
  }

}
